import { parsePhoneNumberFromString, CountryCode } from 'libphonenumber-js';

export const processPurchaseOrderNumbers = (
    purchaseOrderNumber: string,
    setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void,
    setFieldError: (field: string, message: string | undefined) => void,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
    setLocalErrorMessage: (message: string | null) => void
  ) => {
    const purchaseOrderNumberList = [];
    const purchaseOrderNumbers = purchaseOrderNumber.split(';');
    const uniquePOs = new Set();
    let hasDuplicates = false;
  
    for (let po of purchaseOrderNumbers) {
      const trimmedPO = po.trim();
      if (trimmedPO) {
        if (uniquePOs.has(trimmedPO)) {
          hasDuplicates = true;
          setFieldTouched('purchaseOrderNumber', true);
          setFieldError('purchaseOrderNumber', 'Duplicate purchase order numbers are not allowed');
          setLocalErrorMessage('Duplicate purchase order numbers are not allowed');
          break;
        }
        uniquePOs.add(trimmedPO);
        purchaseOrderNumberList.push(trimmedPO);
      }
    }
  
    if (hasDuplicates) {
      setFieldTouched('purchaseOrderNumber', true);
      setFieldError('purchaseOrderNumber', 'Duplicate purchase order numbers are not allowed');
      setLocalErrorMessage('Duplicate purchase order numbers are not allowed');
    } else {
      setFieldValue('purchaseOrderNumberList', purchaseOrderNumberList);
      setFieldError('purchaseOrderNumber', ''); // Clear any existing error
    }
  };
  
  export const validateAndProcessInputValue = (
    inputValue: string,
    values: any,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
    setLocalErrorMessage: (message: string | null) => void,
    requestType:string
  ) => {
   
    if (inputValue.trim() !== '') {
      const newPOs = inputValue.split('\n').map(po => po.trim()).filter(po => po !== '');
  
      // Validation for Pepsi and Arlington or Grand Prairie location
      if (values.programInfo === 'Pepsi' && values.arlingtonOrGrandPrairieLocationFlag === 'Yes') {

        const invalidPOs = newPOs.filter(po => !/^4500\d{6}$/.test(po));
        
        if (invalidPOs.length > 0) {
          setLocalErrorMessage('Purchase Order number should begin with 4500 and be 10 digits long.');
          return;
        }
      }
     
      // Validation for PQGI Purchase Order Number
      if (requestType === 'PQGI') {
        const invalidPOs = newPOs.filter(po => !/^(45|76)\d{8}$/.test(po));
       
        if (invalidPOs.length > 0) {
          setLocalErrorMessage('PQGI Purchase Order Number must have 10 digits and must start either with 45 or 76.');
          return;
        }
      }

        // Validation for Quaker or Gatorade Cost Center
   /*  if ((values.programInfo === 'Quaker' || values.programInfo === 'Gatorade') && newPOs.some(po => po.startsWith('41'))) {
      if (!values.costCenter.startsWith('2') && !values.costCenter.startsWith('3')) {
        setLocalErrorMessage('Cost Center must begin with 2 or 3 when Purchase Order Number begins with 41.');
        return;
      }
    } */
  
      const existingPOs = values.purchaseOrderNumberList || [];
      const combinedPOs = [...existingPOs, ...newPOs];
      const uniquePOs = Array.from(new Set(combinedPOs));
  
      if (uniquePOs.length > 20) {
        setLocalErrorMessage('The list of PO numbers should not exceed 20.');
        return;
      }
  
      if (combinedPOs.length !== uniquePOs.length) {
        setLocalErrorMessage('Duplicate purchase order numbers are not allowed.');
        return;
      }
  
      setFieldValue('purchaseOrderNumberList', uniquePOs);
      setFieldValue('purchaseOrderNumber', uniquePOs.join('; ') + ';'); // Update the input field with the list and ensure it ends with a semicolon
      setLocalErrorMessage(null); // Clear any existing error message
    }
  };  
  export const formatPhoneNumber = (phoneNumber: string, country: string = 'US'): string => {
      // Remove all non-numeric characters
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');

  // Check if the cleaned number has 10 digits
  if (cleaned.length === 10) {
    // Format the number as (XXX) XXX-XXXX
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
  }

  // If the number is not 10 digits, return the original input
  return phoneNumber;
  };